import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Mutations } from "../enums/StoreEnums";

@Module
export default class DataModule extends VuexModule {
    id = ""
    _type = ""
    percentage = {
        fileName: '',
        extension: '',
        percent: '0.00'
    }

    get dataId(): string {
        return this.id;
    }

    get _dataType(): string {
        return this._type;
    }

    get downloadPercentage() {
        return this.percentage;
    }

    @Mutation
    [Mutations.SET_ID](id) {
        this.id = id;
    }

    @Mutation
    [Mutations.SET_DATA_TYPE](dataType) {
        this._type = dataType;
    }

    @Mutation
    [Mutations.SET_PERCENTAGE](percentage) {
        this.percentage = percentage;
    }
}